module.exports = __webpack_public_path__ + "img/Katarina_home_14.d5f62700.jpg";